export enum ErrorType {
  Common = 'common',
  NothingFound = 'nothingFound',
}
